<template>
  <div :class="{'background-white': this.$route.path !== '/enrollment/join' && this.$route.path !== '/enrollment/trial' ,'flex-height':this.$route.path === '/'}"  >
    <approachHeader class="fixed"></approachHeader>
    <div class="header_height"></div>

    <v-container style="margin:auto" fluid :class="{'container-option':this.$route.path !== '/','py-0 px-0':this.$route.path === '/'}">
      <router-view />
    </v-container>

    <approachFooter></approachFooter>

  </div>
</template>

<script>
import approachHeader from '@/components/approach/Header.vue'
import approachFooter from '@/components/approach/Footer.vue'

export default {
  name: 'approach-index',
  components: {
    approachHeader,
    approachFooter
  },
  mounted: function () {
  }
}
</script>

<style scoped>
.container-option{
  max-width:860px;
  margin: auto;
}
.header_height{
  height:64px;
  width:100vw;
}
.flex-height{
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

</style>
